const { EventCodes } = require('../../../../App/model/event-codes');

MxShellOperationMonitorController.$inject = [
	'$timeout',
	'mx.internationalization',
	'mx.shell.BackgroundProcessesService',
	'mx.shell.SidebarService',
	'mx.shell.View',
	'mx.shell.EventService',
	'mx.shell.AppsService',
	'$scope',
];

function MxShellOperationMonitorController($timeout, i18n, backgroundProcesses, sidebarService, MxView, eventService, appsService, $scope) {
	const vm = this;

	vm.$onInit = function () {
		vm.service = backgroundProcesses;
		vm.openBackgroundProcesses = openBackgroundProcesses;
		vm.isReloadingRequired = false;

		// TODO: temporary solution, sidebar needs to have stack design
		vm._sidebarCurrentView = null;
		vm._sidebarCurrentButtons = null;
	};

	eventService.subscribeTo(
		EventCodes.ForegroundProcessCreated,
		function (_, process) {
			const currentApp = appsService.getCurrentApplicationSync();
			if (currentApp?.showOperationMonitor && process.longRunning) {
				vm.openBackgroundProcesses();
			}
		},
		$scope
	);

	return vm;

	function openBackgroundProcesses() {
		if (sidebarService.view && sidebarService.view.id === '__background_processes_view__') {
			return;
		}
		vm._sidebarCurrentView = sidebarService.view;
		vm._sidebarCurrentButtons = sidebarService.additionalButtons;

		const backgroundProcessesView = new MxView({
			controller: [
				'$element',
				function ($element) {
					onShow();
					$element.on('$destroy', onClose);
				},
			],
			id: '__background_processes_view__',
			name: i18n.get('shell.mx-shell-background-processes.operations-in-process'),
			template: '<mx-shell-background-processes></mx-shell-background-processes>',
		});

		sidebarService.open(backgroundProcessesView);
	}

	function onShow() {
		vm.isReloadingRequired = true;
		vm.service.reloadOnAdd = true;
		reload();
	}

	function reload() {
		if (vm.isReloadingRequired) {
			vm.service.loadBackgroundProcesses();
			$timeout(reload, 10000);
		}
	}

	function onClose() {
		vm.isReloadingRequired = false;
		vm.service.reloadOnAdd = false;
		if (vm._sidebarCurrentView) {
			sidebarService.open(vm._sidebarCurrentView, vm._sidebarCurrentButtons);
		}
	}
}

angular.module('mx.components').component('mxShellOperationMonitor', {
	controller: MxShellOperationMonitorController,
	controllerAs: 'vm',
	templateUrl: 'components/mx-shell-operation-monitor/mx-shell-operation-monitor.html',
});
